export enum DeliveryDirections {
  Import = 'import',
  Export = 'export',
  Both = 'both',
}
